export const RQ_GET_MY_ASSET_API = {
  url: 'assetinventory/assignments/<%= employeeId %>/<%= status %>',
  method: 'GET',
  auth: true,
};
